<template>
  <div class="audit-type-summary">
    <span class="audit-type-summary__main">
      {{ summaryText }}
    </span>
    <AuditStandardCycleDetails
      v-if="showDetails"
      :details="details"
      :audit-degree="auditDegree"
      :show-when-single="showDetailsWhenSingle"
    />
  </div>
</template>

<script>
import AuditStandardCycleDetails from '@/components/AuditStandardCycleDetails.vue'
import { auditTypeLabel, normalizeAuditType } from '@/utils/auditTypes'

export default {
  name: 'AuditTypeSummary',
  components: {
    AuditStandardCycleDetails
  },
  props: {
    auditType: {
      type: String,
      default: ''
    },
    auditDegree: {
      type: String,
      default: ''
    },
    details: {
      type: Array,
      default: () => []
    },
    suffix: {
      type: String,
      default: '심사'
    },
    showDetailsWhenSingle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    normalizedType() {
      return normalizeAuditType(this.auditType)
    },
    summaryText() {
      const label = auditTypeLabel(this.normalizedType)
      const degree = String(this.auditDegree || '').trim()
      const degreePrefix = degree && degree !== '혼합' && this.normalizedType === '사후'
        ? `${degree} `
        : ''
      return `${degreePrefix}${label}${this.suffix || ''}`.trim()
    },
    showDetails() {
      return this.normalizedType === '혼합' || String(this.auditDegree || '') === '혼합' || this.details.length > 1
    }
  }
}
</script>

<style scoped>
.audit-type-summary__main {
  font-weight: 600;
}
</style>
